<template>
  <div class="big">
    <div class="container">
      <div class="searchbox">
        <div>
          <span>长链接/备注</span>
          <el-input
            v-model="keywords"
            style="width: 160px; margin: 0 20px 0 10px"
            @change="search"
            clearable
          ></el-input>
          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981"
            @click="search"
          >查询</el-button>
          <span style="margin: 0 10px 0 15px">状态</span>
          <el-radio-group
            v-model="status"
            @change="search"
          >
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">已启用</el-radio>
            <el-radio :label="0">已禁用</el-radio>
          </el-radio-group>
        </div>
        <el-button
          type="primary"
          @click="AddLink"
          style="width: 120px"
          :disabled="
                  module_id_array[0] ? !module_id_array.includes('1266') : false
                "
        >生成短链接</el-button>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
          @sort-change="changeOrder"
        >
          <el-table-column
            label="创建时间"
            prop="create_time"
          ></el-table-column>
          <el-table-column
            label="长链接"
            prop="long_link"
          ></el-table-column>
          <el-table-column
            label="备注"
            prop="remark"
          ></el-table-column>
          <el-table-column
            label="有效时长"
            prop="expiry_day"
          >
          </el-table-column>
          <el-table-column
            prop="last_time"
            label="到期时间"
          ></el-table-column>
          <el-table-column
            prop="short_link"
            label="短链接"
          >
            <template slot-scope="scope">
              <span> {{scope.row.short_link}}</span>
              <el-button
                type="text"
                icon="el-icon-document-copy"
                style="margin-left:5px"
                @click="copyLink(scope.row.short_link)"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="click_num"
            label="点击次数"
            sortable="custom"
          ></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status">已启用</span>
              <span
                v-else
                style="color: #e53528"
              >已禁用</span>
              <el-switch
                style="margin-left:6px"
                v-model="scope.row.status"
                active-color="#669961"
                :active-value="1"
                :inactive-value="0"
                @change="value=>{return editStatus(value,scope.row.short_link_id)}"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1265') : false
                "
              >
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin:20px 0"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="生成短链接"
      :visible.sync="addlink"
      width="550px"
      :close-on-click-modal="false"
    >
      <div class="myform">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="长链接"
            prop="long_link"
          >
            <el-input v-model="ruleForm.long_link"></el-input>
          </el-form-item>
          <el-form-item
            label="有效时长"
            prop="expiry_day"
          >
            <el-select
              v-model="ruleForm.expiry_day"
              placeholder="请选择"
            >
              <el-option
                label="3天"
                :value="3"
              ></el-option>
              <el-option
                label="15天"
                :value="15"
              ></el-option>
              <el-option
                label="30天"
                :value="30"
              ></el-option>
              <el-option
                label="365天"
                :value="365"
              ></el-option>
              <el-option
                label="永久"
                :value="0"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              v-model="ruleForm.remark"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: left; padding: 50px 0 20px 130px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            style="width: 92px"
            size="medium"
          >保 存</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      keywords: '',
      status: '',
      orderby: 0,
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      addlink: false,
      ruleForm: {
        expiry_day: 3,
        long_link: '',
        remark: ''
      },
      rules: {
        expiry_day: [
          {
            required: true,
            message: '请选择有效期',
            trigger: 'blur'
          }
        ],
        long_link: [
          { required: true, message: '请输入长连接', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取用户列表
    getList() {
      let data = {
        status: this.status,
        keywords: this.keywords,
        link_type: 1,
        orderby: this.orderby,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios.post('platform/Admin/shortLinkList', data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            item.last_time =
              item.last_time == '永久'
                ? item.last_time
                : dayjs.unix(item.last_time).format('YYYY-MM-DD HH:mm');
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      //升序
      if (order == 'ascending') {
        this.orderby = 'asc';
      }
      //降序
      if (order == 'descending') {
        this.orderby = 'desc';
      }
      if (!order) {
        this.orderby = 0;
      }
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //添加用户按钮
    AddLink() {
      this.ruleForm = {
        expiry_day: 3,
        long_link: '',
        remark: ''
      };
      this.addlink = true;
    },
    //添加
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          this.axios.post('platform/Admin/saveShortLink', data).then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功');
              this.addlink = false;
              this.getList();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //作废 恢复
    editStatus(status, short_link_id) {
      let msg = '确定禁用该短链接吗？';
      if (status) {
        msg = '确定启用该短链接吗？';
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Admin/updateShortLinkStatus', {
              short_link_id,
              status
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('状态已修改');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    copyLink(short_link) {
      let oInput = document.createElement('input');
      oInput.value = short_link;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand('Copy');
      oInput.remove();
      this.$message({
        message: '复制成功',
        type: 'success'
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 200px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
  text-align: left;
}
</style>